<canvas style="width: 100%; height: 100%" (mousedown)="onCanvasMouseDown()"></canvas>
<div class="placeholder">
  <ng-container *ngIf="!hasSignature">
    {{ placeholder }}
  </ng-container>
</div>
